<template>
    <div class="mx-sm-1 mt-9">
        <div class="page-header">
            <h1 class="page-title fw-bold">Les Cadrages</h1>
            <div>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><router-link :to="{ name: 'dashboard' }"><a>Tableau de
                                bord</a></router-link></li>
                    <li class="breadcrumb-item active" aria-current="page"><router-link
                            :to="{ name: 'classeurs' }"><a>Les Cadrages</a></router-link></li>
                </ol>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">

                <div class="modal fade" id="cadrage" tabindex="-1" role="dialog">
                    <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                        <div class="modal-content" style="background-color: #f0f0f5!important;">
                            <div class="modal-header bg-primary text-white">
                                <h6 class="modal-title fw-bold text-uppercase" style="font-size: 16px;">Déclaration du
                                    cadrage (BUDGET NATIONAL)
                                </h6>
                                <button aria-label="Close" class="btn-close text-white" data-bs-dismiss="modal"
                                    type="button"><span aria-hidden="true" @click="fermer">×</span></button>
                            </div>
                            <div class="modal-body">
                                <div class="accordion" id="accordionPanelsStayOpenExample">
                                    <div class="accordion-item ">
                                        <h3 class="accordion-header fw-bold m-3">
                                            <i class="fe fe-tag fs-18 fw-bold"> </i> PROJET PAG :
                                            <a class="accordion-button fw-bold" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="false"
                                                aria-controls="panelsStayOpen-collapseOne">

                                                {{
                                                    payload?.idProjetPag?.nomProjetPag ?
                                                        payload?.idProjetPag?.nomProjetPag : '---' }}
                                            </a>
                                        </h3>
                                        <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse">
                                            <div class="accordion-body">

                                                <div class="row mb-3">
                                                    <div class="col-md-12">
                                                        <div class="card h-100">
                                                            <div class="card-body alert alert-secondary shadow shadow">
                                                                <label for="" class="fw-bold">Action : </label>
                                                                <p class="card-text fw-bold">
                                                                    <i class="fe fe-tag fs-18"></i> {{
                                                                        payload?.idProjetPag?.idAction?.libelleAction
                                                                    }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <hr>
                                <div class="row">

                                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label class="form-label">Année <span
                                                                    class="text-danger">*</span></label>
                                                            <multi-select deselect-label="Sélectionné" select-label=""
                                                                :options="exercices"
                                                                placeholder="Sélectionné une année " label="annee"
                                                                track-by="annee" :searchable="true"
                                                                :custom-label="o => o.annee" v-model="cadrage.annee">
                                                                <template slot="singleLabel" slot-scope="{ option }">
                                                                    <strong> {{ option.annee }}</strong>
                                                                </template>
                                                                <span slot="noOptions">
                                                                    <strong>Liste Vide</strong>
                                                                </span>
                                                                <span slot="noResult">
                                                                    <strong>Aucun Résultat</strong>
                                                                </span>
                                                            </multi-select>

                                                        </div>
                                                    </div>

                                                </div>
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label class="form-label">Montant du cadrage <span
                                                                    class="text-danger">*</span></label>
                                                            <input type="number" class="form-control"
                                                                v-model="cadrage.montantCpBn">

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-footer my-3 d-flex">
                                                <div class="col-md-6">
                                                    <button @click=saver() class="btn btn-success mt-4 mb-0"
                                                        :disabled="invalid || loading" v-if="save"><span
                                                            class="fe fe-check"></span>
                                                        Enregistrer
                                                        <span v-if="loading" class="text-center">
                                                            <i class="fa fa-spinner fa-spin fa-2x"></i>
                                                        </span>
                                                    </button>
                                                    <button class="btn btn-success mt-4 mb-0" @click=saver()
                                                        :disabled="invalid || loading" v-else><span
                                                            class="fe fe-check"></span>
                                                        Modifier
                                                        <span v-if="loading" class="text-center">
                                                            <i class="fa fa-spinner fa-spin fa-2x"></i>
                                                        </span>
                                                    </button>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6">
                                        <div class="card">
                                            <div class="card-body">
                                                <p class="text-end">(En miliers de FCFA TTC)</p>
                                                <table
                                                    class="table table-striped table-bordered text-nowrap border-bottom mb-0"
                                                    id="my">
                                                    <thead class="border-top text-white"
                                                        style="background-color: #457e9e!important;">
                                                        <tr class="fw-bold">
                                                            <th class="bg-transparent border-bottom-0 fw-bold"
                                                                style="width: 10%;" @click="sortByCadrage('annee')">
                                                                Année
                                                            </th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold text-end"
                                                                @click="sortByCadrage('montantCpBn')">
                                                                Montant CP BN
                                                            </th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"
                                                                style="width: 5%;">
                                                                Actions
                                                            </th>
                                                        </tr>
                                                    </thead>

                                                    <!-- FOOTER pour le total -->
                                                    <tfoot>
                                                        <tr class="fw-bold border-top">
                                                            <td class="fw-bold">Total</td>
                                                            <td colspan="1" class="fw-bold text-end">{{
                                                                totalMontant.toLocaleString('fr-FR') }}</td>
                                                                <td></td>

                                                        </tr>
                                                    </tfoot>

                                                    <tbody v-if="cadrages.length > 0" id="myTable1">
                                                        <tr v-for="(item, index) in sortedCadrages" :key="item.idCadrage"
                                                            class="border-bottom">
                                                            <td>
                                                                <span class="fw-bold">{{ item?.annee?.annee }}</span>
                                                            </td>
                                                            <td class="text-end">
                                                                <span class="fw-bold ">{{
                                                                    item?.montantCpBn.toLocaleString('fr-FR') }}</span>
                                                            </td>
                                                            <td>
                                                                <button class="btn btn-warning btn-sm text-white "
                                                                    @click.prevent="editItem(item)"
                                                                    :disabled="loadingRow === item.idCadrage">
                                                                    <span class="fe fe-edit fs-18"></span>
                                                                </button>
                                                                <button class="btn btn-danger btn-sm text-white m-1"
                                                                    @click.prevent="drop(item)"
                                                                    :disabled="loadingRow === item.idCadrage">
                                                                    <span v-if="loadingRow !== item.idCadrage"
                                                                        class="fe fe-trash fs-18"></span>
                                                                    <span v-else class="text-center">
                                                                        <i class="fa fa-spinner fa-spin fa-2x"></i>
                                                                    </span>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>

                                                    <tbody v-else>
                                                        <tr class="primary02">
                                                            <td colspan="3" class="text-center">Aucun cadrage trouvé
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>


                                        </div>
                                    </div>
                                </div>


                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-gray" data-bs-dismiss="modal" @click="fermer">Fermer</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title fw-bold">Programme pluriannuelle des dépenses : Cadre de Dépenses à Moyen
                            Terme - CDMT
                        </h3>
                        <div class="card-options">
                            <SearchInputAll></SearchInputAll>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="my-2">
                            <button class="btn btn-info text-start" @click="toggleAll">
                                <span :class="allExpanded ? 'fe fe-minus' : 'fe fe-plus'"></span>
                                {{ allExpanded ? 'Replier' : 'Déplier' }}
                            </button>
                            <p class="text-end">(En miliers FCFA TTC)</p>
                        </div>

                        <div class="table-responsive">
                            <table class="table table-hover table-bordered text-wrap border-bottom mb-0" id="my">
                                <thead class="border-top text-white" style="background-color: #457e9e!important;">
                                    <tr class="fw-bold">
                                        <th class="bg-transparent border-bottom-0 fw-bold" style=""
                                            @click="sortBy('action')">Action
                                            et projet</th>
                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                            @click="sortBy('montantCpBn')">
                                            {{ anneeMoinsDeux }}</th>
                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                            @click="sortBy('montantCpBn')">
                                            {{ anneeMoinsUn }}</th>
                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                            @click="sortBy('montantCpBn')"> {{ annee }}
                                        </th>
                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                            @click="sortBy('montantCpBn')">
                                            {{ anneePlusUn }}</th>
                                        <th class="bg-transparent border-bottom-0 fw-bold" style="width: 5%;">Actions
                                        </th>
                                    </tr>
                                </thead>

                                <tfoot>
                                    <tr class="fw-bold bg-light">
                                        <td class="text-end">Total :</td>
                                        <td>{{ totalAnneeMoinsDeux.toLocaleString('fr-FR') }}</td>
                                        <td>{{ totalAnneeMoinsUn.toLocaleString('fr-FR') }}</td>
                                        <td>{{ totalAnnee.toLocaleString('fr-FR') }}</td>
                                        <td>{{ totalAnneePlusUn.toLocaleString('fr-FR') }}</td>
                                        <td></td>
                                    </tr>

                                </tfoot>

                                <tbody v-if="filtersItems.length > 0" id="myTable1">
                                    <template v-for="(item, index) in filtersItems">
                                        <!-- Ligne principale -->
                                        <tr class="border-bottom" style="background-color: #d0e6e9;">
                                            <td colspan="5">
                                                <p class="fw-bold mb-0 text-break"
                                                    style="white-space: normal; word-break: break-word;">
                                                    {{ item.action }}
                                                </p>
                                            </td>
                                            <td>
                                                <button class="btn btn-warning btn-sm text-white"
                                                    @click.prevent="toggleDetail(item)">
                                                    <span class="fe fe-eye fs-18"></span>
                                                </button>
                                            </td>
                                        </tr>

                                        <!-- Composantes, affichées uniquement si item sélectionné -->
                                        <tr v-for="(projet, idx) in item.items" :key="`compo-${index}-${idx}`"
                                            v-if="selectedItem === item || selectedItem === 'ALL'">
                                            <td colspan="1">{{ projet.nomProjetPag }}</td>

                                            <td class="text-end">
                                                <div
                                                    v-if="projet.cadrages.filter(c => c.annee.annee == anneeMoinsDeux).length === 0">
                                                    0
                                                </div>
                                                <div v-else
                                                    v-for="cadrage in projet.cadrages.filter(c => c.annee.annee == anneeMoinsDeux)"
                                                    :key="cadrage.idCadrage">
                                                    {{ cadrage.montantCpBn.toLocaleString('fr-FR') }}

                                                </div>
                                            </td>
                                            <td class="text-end">
                                                <div
                                                    v-if="projet.cadrages.filter(c => c.annee.annee == anneeMoinsUn).length === 0">
                                                    0
                                                </div>
                                                <div v-else
                                                    v-for="cadrage in projet.cadrages.filter(c => c.annee.annee == anneeMoinsUn)"
                                                    :key="cadrage.idCadrage">
                                                    {{ cadrage.montantCpBn.toLocaleString('fr-FR') }}
                                                </div>
                                            </td>
                                            <td class="text-end">
                                                <div
                                                    v-if="projet.cadrages.filter(c => c.annee.annee == annee).length === 0">
                                                    0
                                                </div>
                                                <div v-else
                                                    v-for="cadrage in projet.cadrages.filter(c => c.annee.annee == annee)"
                                                    :key="cadrage.idCadrage">
                                                    {{ cadrage.montantCpBn.toLocaleString('fr-FR') }}
                                                </div>
                                            </td>
                                            <td class="text-end">
                                                <div
                                                    v-if="projet.cadrages.filter(c => c.annee.annee == anneePlusUn).length === 0">
                                                    0
                                                </div>
                                                <div v-else
                                                    v-for="cadrage in projet.cadrages.filter(c => c.annee.annee == anneePlusUn)"
                                                    :key="cadrage.idCadrage">
                                                    {{ cadrage.montantCpBn.toLocaleString('fr-FR') }}
                                                </div>
                                            </td>
                                            <td>
                                                <button class="btn btn-primary btn-sm text-white"
                                                    @click.prevent="edit(projet)">
                                                    <span class="fe fe-edit fs-18"></span>
                                                </button>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>

                                <tbody v-else>
                                    <tr class="primary02">
                                        <td colspan="6" class="text-center">Aucun Cadrages trouvé</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <nav v-if="pageCount > 1" class="mt-2">
                            <ul class="pagination justify-content-end">
                                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                    <a class="page-link" href="#"
                                        @click.prevent="changePage(currentPage - 1)">&laquo;</a>
                                </li>
                                <li v-for="page in pageCount" :key="page" class="page-item"
                                    :class="{ active: currentPage === page }">
                                    <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                                </li>
                                <li class="page-item" :class="{ disabled: currentPage === pageCount }">
                                    <a class="page-link" href="#"
                                        @click.prevent="changePage(currentPage + 1)">&raquo;</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { reduce } from "lodash";
import $ from 'jquery';
import { query } from 'vue-gtag';
export default {
    name: "Classeurs",
    data() {
        return {
            loading: false, loadingRow: null, allExpanded: '', cadrage: { idCadrage: '', annee: '', montantCpBn: '', idProjetPag: '' },
            payload: { idCadrage: '', idProjetPag: '', nomProjetPag: '', montantCpBn: '', dateMaj: '', annee: '' }, save: true, id: '', selectedItem: null, exercices: {}, cadrages: [],
            currentPage: 1,
            perPage: 10,invalid:false,
            currentSort: 'action',
            currentSortDir: 'asc',
            currentSortCadrage: 'annee',
            currentSortDirCadrage: 'asc',

        }
    },
    computed: {
        ...mapGetters({ items: 'projetPag/list' }),
 
        totalAnneeMoinsDeux() {
            return this.getTotalByAnnee(this.anneeMoinsDeux);
        },
        totalAnneeMoinsUn() {
            return this.getTotalByAnnee(this.anneeMoinsUn);
        },
        totalAnnee() {
            return this.getTotalByAnnee(this.annee);
        },
        totalAnneePlusUn() {
            return this.getTotalByAnnee(this.anneePlusUn);
        },
        getTotalByAnnee() {
            return (anneeStr) => {
                let total = 0;
                this.filtersItems.forEach(item => {
                    item.items?.forEach(projet => {
                        projet.cadrages?.forEach(cadrage => {
                            if (cadrage?.annee?.annee == anneeStr) {
                                total += cadrage.montantCpBn || 0;
                            }
                        });
                    });
                });
                return total;
            };
        },
        totalMontant() {
            return this.cadrages.reduce((sum, item) => sum + (item.montantCpBn || 0), 0);
        },
        annee() {
            return new Date().getFullYear();
        },
        anneePlusUn() {
            return new Date().getFullYear() + 1;
        },
        anneeMoinsUn() {
            return new Date().getFullYear() - 1;
        },
        anneeMoinsDeux() {
            return new Date().getFullYear() - 2;
        },
        groupedItems() {
            console.log(5454545454)
            console.log(this.items)
            return this.items.reduce((groups, item) => {
                
                const actionKey = item.idAction?.idAction || 'Autre';
                if (!groups[actionKey]) {
                    groups[actionKey] = {
                        action: item.idAction?.libelleAction || 'Autre',
                        items: []
                    };
                }
                groups[actionKey].items.push(item);
                return groups;
            }, {});
        },

        sortedItems() {
            console.log(this.groupedItems);
            return Object.values(this.groupedItems).sort((a, b) => {
                const aVal = this.resolveSortValue(a);
                const bVal = this.resolveSortValue(b);
                return this.currentSortDir === 'asc'
                    ? (aVal > bVal ? 1 : -1)
                    : (aVal < bVal ? 1 : -1);
            });
        },

        filtersItems() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.sortedItems.slice(start, start + this.perPage);
        },
        pageCount() {
            return Math.ceil(this.sortedItems.length / this.perPage);
        },
        sortedCadrages() {
            return [...this.cadrages].sort((a, b) => {
                let aVal = this.resolveCadrageSortValue(a);
                let bVal = this.resolveCadrageSortValue(b);

                if (typeof aVal === 'string') aVal = aVal.toLowerCase();
                if (typeof bVal === 'string') bVal = bVal.toLowerCase();

                if (this.currentSortDirCadrage === 'asc') {
                    return aVal > bVal ? 1 : -1;
                } else {
                    return aVal < bVal ? 1 : -1;
                }
            });
        },




    },
    mounted() {
    },
    methods: {
        ...mapActions('projetPag', ['all', 'add', 'one', 'del']),
        fermer() {
            this.$loading(true);
            this.onSearch();
            ("#modal").hide();
            this.$loading(false);

        },
         sortByCadrage(column) {
            if (this.currentSortCadrage === column) {
                this.currentSortDirCadrage = this.currentSortDirCadrage === 'asc' ? 'desc' : 'asc';
            } else {
                this.currentSortCadrage = column;
                this.currentSortDirCadrage = 'asc';
            }
        },
         resolveCadrageSortValue(item) {
            if (this.currentSortCadrage === 'annee') {
                return item.annee?.annee || 0;
            }
            if (this.currentSortCadrage === 'montantCpBn') {
                return item.montantCpBn || 0;
            }
            return item[this.currentSortCadrage];
        },
       
        sortBy(column) {
            if (this.currentSort === column) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
            } else {
                this.currentSort = column;
                this.currentSortDir = 'asc';
            }
        }, toggleAll() {
            this.allExpanded = !this.allExpanded;
            this.selectedItem = this.allExpanded ? 'ALL' : null;
        }, toggleDetail(item) {
            // Si déjà ouvert, fermer ; sinon, ouvrir
            if (this.selectedItem === item) {
                this.selectedItem = null;
            } else {
                this.selectedItem = item;
            }
        }, async saver() {
            //console.log(this.payload);
            this.$loading(true);
            this.loading = true
            this.cadrage.idProjetPag = this.payload.idProjetPag;
            const isUpdate = !!this.cadrage.idCadrage;
            const url = isUpdate ? `/cadrage/${this.cadrage.idCadrage}` : '/cadrage';
            const method = isUpdate ? 'put' : 'post';

            try {

                const response = await this.$http[method](url, this.cadrage);
                this.donnees = response.data;


                if (this.donnees) {

                    await this.chargerCadrageParProjet(this.payload.idProjetPag.idProjetPag);
                    swal(
                        'Information!',
                        isUpdate ? 'Cadrages modifié avec succès.' : 'Cadrages enregistré avec succès.',
                        'success'
                    );
                    this.save = true;
                    this.loading = false
                    // Réinitialisation partielle du formulaire
                    this.cadrage.idCadrage = '';
                    this.cadrage.montantCpBn = 0;
                    this.cadrage.annee = '';
                    this.$loading(false);
                } else {
                    swal('Information!', 'L\'enregistrement du Cadrages n\'a pas pu être effectué.', 'warning');
                }
            } catch (error) {
                console.error('Erreur lors de l\'enregistrement :', error);
                swal('Erreur', 'Une erreur est survenue lors de l\'enregistrement.', 'error');
            } finally {
                this.$loading(false);
            }


        }

        ,
        getExercices() {
            this.$http.get('/exercice')
                .then(({ data }) => {
                    console.log(data);
                    console.log(1);
                    this.exercices = data;

                });
        },
        chargerCadrageParProjet(idProjet) {

            this.$http.get(`/cadrage/projet/` + idProjet)
                .then(({ data }) => {
                    console.log(data);
                    console.log(22);
                    this.cadrages = data;
                });
        }, async chargerCadrageParProjet(idProjet) {
            try {
                const { data } = await this.$http.get(`/cadrage/projet/${idProjet}`);
                console.log('Réponse cadrage :', data);
                this.cadrages = data;
                    this.currentSortCadrage = 'annee';
                    this.currentSortDirCadrage = 'asc';
            } catch (error) {
                console.error('Erreur cadrage :', error);
            }
        }
        ,
        formatDate(dateStr) {
            const date = new Date(dateStr);
            return date.toLocaleDateString('fr-FR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        },
        changePage(page) {
            if (page >= 1 && page <= this.pageCount) {
                this.currentPage = page;
            }
        },
        resolveSortValue(item) {
            const val = item[this.currentSort];
            if (this.currentSort === 'auteur') {
                return item.user?.firstname + ' ' + item.user?.lastname;
            }
            return typeof val === 'string' ? val.toLowerCase() : val;
        },
        onSearch(offset) {
            this.$loading(true);
            if (offset > 0) this.option.page = offset - 1;
            this.$router.push({ query: this.option }).catch(() => { });
            this.$store.dispatch('projetPag/all', this.option).finally(() => this.$loading(false));
        },
        editItem(item) {
            this.cadrage = { ...item }
            console.log(this.cadrage)
            this.save = false;
            this.loading = false;

        },
        // cadrage() {
        //     this.$http.delete('/projetPag/' + item.idClasseur)
        //         .then(({ data }) => {
        //             swal('Information!', 'Cadrages supprimé avec succès.', 'success');
        //             this.onSearch();
        //         })
        //         .catch((error) => {
        //             swal('Information!', 'Une erreur est survenue lors de la suppression. ' + error, 'warning');
        //         })
        //         .finally(() => this.$loading(false));
        // },
        // chargerCadrage() {
        //     alert(3)
        //     this.$loading(true);
        //     this.$http.get(`/cadrage/${this.payload.exercice.annee}/${this.payload.idComposante.idComposante}`)
        //         .then(({ data }) => {

        //             console.log(22);
        //             console.log(data);
        //             this.$loading(false);
        //         });
        // },
        async edit(value) {
            this.payload.idProjetPag = null;
            this.$loading(true);
            this.save = true;

            this.payload.idProjetPag = { ...value };
            console.log("Payload :", this.payload.idProjetPag);

            await this.chargerCadrageParProjet(this.payload.idProjetPag.idProjetPag);
            this.$loading(false);
            // $("#cadrage").modal({ backdrop: 'static', show: true, keyboard: false });
            $('#cadrage').modal('show');

        },
        drop(item) {
            console.log(item);
            this.loadingRow = item.idCadrage;
            this.loading = true;
            this.$loading(true);
            this.$http.delete('/cadrage/' + item.idCadrage)
                .then(() => {
                    return this.chargerCadrageParProjet(this.payload.idProjetPag.idProjetPag);
                })
                .then(() => {
                    swal('Information!', 'Cadrages supprimé avec succès.', 'success');
                })
                .catch((error) => {
                    swal('Erreur', 'Une erreur est survenue : ' + (error?.message || error), 'warning');
                })
                .finally(() => {
                    this.$loading(false);
                    this.loadingRow = null;
                    this.loading = false;
                });
        },

        initializedComposante(item) {
            this.$router.push({ name: 'composantes', params: { idClasseur: item, showList: false } });
        },
    },
    created() {
        this.onSearch();
        this.getExercices();
        this.toggleAll();
    }
}
</script>

<style>
th {
    cursor: pointer;
}

.classeur-nom {
    max-width: 220px;
    white-space: normal !important;
    word-wrap: break-word;
    word-break: break-word;
}
</style>